import { object, string, number, ref, InferType } from "yup";


export const LoginSchema = object().shape({
    username: string().email().required("email is required"),
    password: string().required("password is required"),
})

export const ResetPasswordSchema = object().shape({
    username: string().email("enter a valid email").required("email is required"),
    otp: string().required("otp is required"),
    password: string().min(6, "password must be at least 6 characters").required("password is required"),
    repeatPassword: string()
        .oneOf([ref("password")], "passwords must match")
        .required("repeat password is required"),
})

export const ForgotPasswordSchema = object().shape({
    username: string().email("enter a valid email").required("email is required"),
})

export const PersonalSchema = object().shape({
    salutation: string().required("salutation is required"),
    firstName: string().required("first name is required"),
    lastName: string().required("last name is required"),
    email: string().email().required("otp is required"),
    phone: string().required("phone number is required"),
    password: string().min(6).required("password is required"),
    confirmPassword: string().oneOf([ref("password")], "passwords must match"),
})

export const IdSchema = object().shape({
    nationality: string().required("nationality is required"),
    dateOfBirth: string().optional(),
    idType: string().required("id type password is required"),
    idNumber: string().required("id number password is required"),
    avatarFile: string().optional(),
    idFile: string().required("id file is required"),
})

export const BusinessSchema = object().shape({
    businessName: string().required("business name is required"),
    tradingName: string().optional(),
    tinNumber: number().transform((value, originalValue) => 
        originalValue === "" ? undefined : value
    ).optional(),
    region: string().required("region is required"),
    district: string().required("district is required"),
    street: string().optional(),
    latitude: string().optional(),
    longitude: string().optional(),
    managerName: string().required("manager name is required"),
    managerEmail: string().required("street is required"),
    managerPhone: string().required("phone is required"),
})

export type TLoginSchema = InferType<typeof LoginSchema>;
export type TResetPasswordSchema = InferType<typeof ResetPasswordSchema>;
export type TForgotPasswordSchema = InferType<typeof ForgotPasswordSchema>;
export type TPersonalSchema = InferType<typeof PersonalSchema>;
export type TIdSchema = InferType<typeof IdSchema>;
export type TBusinessSchema = InferType<typeof BusinessSchema>;
